import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import { Toaster } from "sonner";

import { Navbar } from "@/components/sections/Navbar";
import { Hero } from "@/components/sections/Hero";
import { TrustedBy } from "@/components/sections/TrustedBy";
import { Services } from "@/components/sections/Services";
import { IndustryExperience } from "@/components/sections/IndustryExperience";
import { HowWeDeliver } from "@/components/sections/HowWeDeliver";
import { Coverage } from "@/components/sections/Coverage";
import { WhyChoose } from "@/components/sections/WhyChoose";
import { Equipment } from "@/components/sections/Equipment";
import { Certifications } from "@/components/sections/Certifications";
import { Team } from "@/components/sections/Team";
import { Contact } from "@/components/sections/Contact";
import { Footer } from "@/components/sections/Footer";
// NOTE: <Projects /> (src/components/sections/Projects.jsx) is intentionally not rendered.
// It is retained in the codebase to be re-enabled once real project data & photography are available.
import Admin from "@/pages/Admin";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SECTIONS = ["home", "services", "experience", "process", "coverage", "team", "contact"];

const HomePage = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState("home");
  const [content, setContent] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/content`)
      .then((res) => setContent(res.data))
      .catch(() => setContent(null));
  }, []);

  useEffect(() => {
    const onScroll = () => {
      setIsScrolled(window.scrollY > 40);
      for (const id of SECTIONS) {
        const el = document.getElementById(id);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= 120 && rect.bottom >= 120) {
            setActiveSection(id);
            break;
          }
        }
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="bg-[#050F22]">
      <Navbar isScrolled={isScrolled} activeSection={activeSection} />
      <main>
        <Hero content={content} />
        <TrustedBy />
        <Services />
        <IndustryExperience />
        <HowWeDeliver />
        <Coverage />
        <WhyChoose />
        <Equipment />
        <Certifications />
        <Team />
        <Contact content={content} />
      </main>
      <Footer content={content} />
    </div>
  );
};

function App() {
  return (
    <div className="App" data-testid="quanticom-app">
      <Toaster position="top-right" richColors theme="dark" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
